import { normalizeAttachmentCell } from '@streamlain/database-identity';

import { t } from '../../logical/type-presets.js';
import { createFilter } from './create.js';

export const attachmentFilter = [
  createFilter({
    name: 'isEmpty',
    self: t.attachment.instance(),
    args: [] as const,
    label: 'Is empty',
    shortString: () => ': Is empty',
    impl: self => normalizeAttachmentCell(self).isEmpty,
  }),
  createFilter({
    name: 'isNotEmpty',
    self: t.attachment.instance(),
    args: [] as const,
    label: 'Is not empty',
    shortString: () => ': Is not empty',
    impl: self => !normalizeAttachmentCell(self).isEmpty,
  }),
  createFilter({
    name: 'filenameContains',
    self: t.attachment.instance(),
    args: [t.string.instance()] as const,
    label: 'Filename contains',
    shortString: v => (v ? `: Filename contains ${v.value}` : undefined),
    impl: (self, value) => {
      const needle = value.toLowerCase();
      return normalizeAttachmentCell(self).filenames.some(filename =>
        filename.toLowerCase().includes(needle)
      );
    },
  }),
  createFilter({
    name: 'mimeStartsWith',
    self: t.attachment.instance(),
    args: [t.string.instance()] as const,
    label: 'MIME starts with',
    shortString: v => (v ? `: MIME starts with ${v.value}` : undefined),
    impl: (self, value) => {
      const prefix = value.toLowerCase();
      return normalizeAttachmentCell(self).mimeTypes.some(mime =>
        mime.toLowerCase().startsWith(prefix)
      );
    },
  }),
  createFilter({
    name: 'countEqual',
    self: t.attachment.instance(),
    args: [t.number.instance()] as const,
    label: 'File count =',
    shortString: v => (v ? `: Count = ${v.value}` : undefined),
    impl: (self, value) => normalizeAttachmentCell(self).count === value,
  }),
  createFilter({
    name: 'countNotEqual',
    self: t.attachment.instance(),
    args: [t.number.instance()] as const,
    label: 'File count !=',
    shortString: v => (v ? `: Count != ${v.value}` : undefined),
    impl: (self, value) => normalizeAttachmentCell(self).count !== value,
  }),
  createFilter({
    name: 'countGreaterThan',
    self: t.attachment.instance(),
    args: [t.number.instance()] as const,
    label: 'File count >',
    shortString: v => (v ? `: Count > ${v.value}` : undefined),
    impl: (self, value) => normalizeAttachmentCell(self).count > value,
  }),
  createFilter({
    name: 'countGreaterThanOrEqual',
    self: t.attachment.instance(),
    args: [t.number.instance()] as const,
    label: 'File count >=',
    shortString: v => (v ? `: Count >= ${v.value}` : undefined),
    impl: (self, value) => normalizeAttachmentCell(self).count >= value,
  }),
  createFilter({
    name: 'countLessThan',
    self: t.attachment.instance(),
    args: [t.number.instance()] as const,
    label: 'File count <',
    shortString: v => (v ? `: Count < ${v.value}` : undefined),
    impl: (self, value) => normalizeAttachmentCell(self).count < value,
  }),
  createFilter({
    name: 'countLessThanOrEqual',
    self: t.attachment.instance(),
    args: [t.number.instance()] as const,
    label: 'File count <=',
    shortString: v => (v ? `: Count <= ${v.value}` : undefined),
    impl: (self, value) => normalizeAttachmentCell(self).count <= value,
  }),
];
